var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref14 = /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd_1843_4617",
  x: 0.625,
  y: 0.75,
  width: 80.75,
  height: 80.75,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.125
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.125
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1843_4617"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.125
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.1875
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1843_4617",
  result: "effect2_dropShadow_1843_4617"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1843_4617",
  result: "shape"
}));

function SvgLogoSpearly2(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1843_4617)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1843_4617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 32.2C7 22.6791 7 17.9187 8.85289 14.2822C10.4827 11.0834 13.0834 8.48274 16.2822 6.85289C19.9187 5 24.6791 5 34.2 5H47.8C57.3209 5 62.0813 5 65.7178 6.85289C68.9166 8.48274 71.5173 11.0834 73.1471 14.2822C75 17.9187 75 22.6791 75 32.2V45.8C75 55.3209 75 60.0813 73.1471 63.7178C71.5173 66.9166 68.9166 69.5173 65.7178 71.1471C62.0813 73 57.3209 73 47.8 73H34.2C24.6791 73 19.9187 73 16.2822 71.1471C13.0834 69.5173 10.4827 66.9166 8.85289 63.7178C7 60.0813 7 55.3209 7 45.8V32.2Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 32.2C7 22.6791 7 17.9187 8.85289 14.2822C10.4827 11.0834 13.0834 8.48274 16.2822 6.85289C19.9187 5 24.6791 5 34.2 5H47.8C57.3209 5 62.0813 5 65.7178 6.85289C68.9166 8.48274 71.5173 11.0834 73.1471 14.2822C75 17.9187 75 22.6791 75 32.2V45.8C75 55.3209 75 60.0813 73.1471 63.7178C71.5173 66.9166 68.9166 69.5173 65.7178 71.1471C62.0813 73 57.3209 73 47.8 73H34.2C24.6791 73 19.9187 73 16.2822 71.1471C13.0834 69.5173 10.4827 66.9166 8.85289 63.7178C7 60.0813 7 55.3209 7 45.8V32.2Z",
    fill: "url(#paint0_linear_1843_4617)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 9.33247C24.6151 9.33247 11.3325 22.615 11.3325 38.9999C11.3325 55.3848 24.6151 68.6674 41 68.6674C57.3849 68.6674 70.6675 55.3848 70.6675 38.9999C70.6675 22.615 57.3849 9.33247 41 9.33247ZM11.1675 38.9999C11.1675 22.5239 24.524 9.16742 41 9.16742C57.4761 9.16742 70.8325 22.5239 70.8325 38.9999C70.8325 55.476 57.4761 68.8325 41 68.8325C24.524 68.8325 11.1675 55.476 11.1675 38.9999Z",
    fill: "#D0D5DD",
    style: (_ref2 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 30.6655C36.3967 30.6655 32.665 34.3972 32.665 39.0004C32.665 43.6037 36.3967 47.3354 41 47.3354C45.6033 47.3354 49.335 43.6037 49.335 39.0004C49.335 34.3972 45.6033 30.6655 41 30.6655ZM32.5 39.0004C32.5 34.306 36.3056 30.5004 41 30.5004C45.6944 30.5004 49.5 34.306 49.5 39.0004C49.5 43.6948 45.6944 47.5004 41 47.5004C36.3056 47.5004 32.5 43.6948 32.5 39.0004Z",
    fill: "#D0D5DD",
    style: (_ref3 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9998 33.3051C37.855 33.3051 35.3057 35.8545 35.3057 38.9993C35.3057 42.1441 37.855 44.6935 40.9998 44.6935C44.1447 44.6935 46.694 42.1441 46.694 38.9993C46.694 35.8545 44.1447 33.3051 40.9998 33.3051ZM35.1406 38.9993C35.1406 35.7633 37.7639 33.1401 40.9998 33.1401C44.2358 33.1401 46.8591 35.7633 46.8591 38.9993C46.8591 42.2353 44.2358 44.8585 40.9998 44.8585C37.7639 44.8585 35.1406 42.2353 35.1406 38.9993Z",
    fill: "#D0D5DD",
    style: (_ref4 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9175 5H41.0825V73H40.9175V5Z",
    fill: "#D0D5DD",
    style: (_ref5 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 38.917L75 39.082L7 39.082L7 38.917L75 38.917Z",
    fill: "#D0D5DD",
    style: (_ref6 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5293 5H63.6943V73H63.5293V5Z",
    fill: "#D0D5DD",
    style: (_ref7 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6118 5H29.7769V73H29.6118V5Z",
    fill: "#D0D5DD",
    style: (_ref8 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2231 5H52.3882V73H52.2231V5Z",
    fill: "#D0D5DD",
    style: (_ref9 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref9, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3057 5H18.4707V73H18.3057V5Z",
    fill: "#D0D5DD",
    style: (_ref0 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref0, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref0, "fillOpacity", 1), _ref0)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 61.5283L75 61.6934L7 61.6934L7 61.5283L75 61.5283Z",
    fill: "#D0D5DD",
    style: (_ref1 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref1, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref1, "fillOpacity", 1), _ref1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 27.6113L75 27.7764L7 27.7764L7 27.6113L75 27.6113Z",
    fill: "#D0D5DD",
    style: (_ref10 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 50.2227L75 50.3877L7 50.3877L7 50.2227L75 50.2227Z",
    fill: "#D0D5DD",
    style: (_ref11 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 16.3057L75 16.4707L7 16.4707L7 16.3057L75 16.3057Z",
    fill: "#D0D5DD",
    style: (_ref12 = {
      fill: "#D0D5DD"
    }, _defineProperty(_ref12, "fill", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref12, "fillOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3457 27.3428C47.6163 27.3428 44.8866 28.3819 42.8087 30.4597L32.4598 40.8088C31.7295 41.5389 31.7295 42.7227 32.4598 43.453C32.8248 43.8181 33.3034 44.0007 33.7818 44.0007C34.2604 44.0007 34.7389 43.8181 35.104 43.453L45.4529 33.1041C46.802 31.755 48.574 31.0807 50.3457 31.0807C52.1177 31.0807 53.8896 31.755 55.2387 33.1041C57.9365 35.8021 57.9367 40.192 55.239 42.8899L44.8899 53.2388C43.5408 54.5877 41.7688 55.2622 39.9968 55.2622C38.2249 55.2622 36.4529 54.5877 35.104 53.2388C34.7389 52.8736 34.2604 52.6911 33.7818 52.6911C33.3034 52.6911 32.8248 52.8736 32.4598 53.2388C31.7295 53.9689 31.7295 55.1527 32.4598 55.883C34.5377 57.9608 37.2676 58.9999 39.997 58.9999C42.7267 59.0001 45.456 57.9611 47.534 55.8832L57.8829 45.5341C62.0391 41.3782 62.0389 34.6159 57.8829 30.4597C55.8048 28.3819 53.0754 27.3428 50.3457 27.3428Z",
    fill: "url(#paint1_linear_1843_4617)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0028 19C39.2733 19 36.5439 20.039 34.4658 22.1171L24.1169 32.466C19.961 36.6219 19.961 43.3842 24.1172 47.5404C26.195 49.6182 28.9245 50.6573 31.6541 50.6573C34.3836 50.6573 37.1133 49.6182 39.1911 47.5404L49.54 37.1913C50.2703 36.4612 50.2703 35.2774 49.54 34.5471C49.1751 34.182 48.6964 33.9994 48.218 33.9994C47.7396 33.9994 47.261 34.182 46.8958 34.5471L36.547 44.896C35.1981 46.2451 33.4261 46.9196 31.6541 46.9196C29.8822 46.9196 28.1102 46.2451 26.7611 44.896C24.0634 42.198 24.0631 37.8081 26.7609 35.1101L37.1102 24.7613C38.4589 23.4124 40.231 22.7379 42.0028 22.7379C43.775 22.7379 45.5467 23.4122 46.8958 24.7613C47.261 25.1264 47.7396 25.309 48.218 25.309C48.6964 25.309 49.1751 25.1264 49.54 24.7613C50.2703 24.0312 50.2703 22.8474 49.54 22.1171C47.4621 20.039 44.7325 19 42.0028 19Z",
    fill: "url(#paint2_linear_1843_4617)",
    style: {}
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.2125 32.2C7.2125 27.436 7.21267 23.8759 7.44341 21.0517C7.67394 18.2301 8.13359 16.1619 9.04223 14.3786C10.6517 11.2199 13.2199 8.6517 16.3786 7.04223C18.1619 6.13359 20.2301 5.67394 23.0517 5.44341C25.8759 5.21267 29.436 5.2125 34.2 5.2125H47.8C52.564 5.2125 56.1241 5.21267 58.9483 5.44341C61.7699 5.67394 63.8381 6.13359 65.6214 7.04223C68.7801 8.6517 71.3483 11.2199 72.9578 14.3786C73.8664 16.1619 74.3261 18.2301 74.5566 21.0517C74.7873 23.8759 74.7875 27.436 74.7875 32.2V45.8C74.7875 50.564 74.7873 54.1241 74.5566 56.9483C74.3261 59.7699 73.8664 61.8381 72.9578 63.6214C71.3483 66.7801 68.7801 69.3483 65.6214 70.9578C63.8381 71.8664 61.7699 72.3261 58.9483 72.5566C56.1241 72.7873 52.564 72.7875 47.8 72.7875H34.2C29.436 72.7875 25.8759 72.7873 23.0517 72.5566C20.2301 72.3261 18.1619 71.8664 16.3786 70.9578C13.2199 69.3483 10.6517 66.7801 9.04223 63.6214C8.13359 61.8381 7.67394 59.7699 7.44341 56.9483C7.21267 54.1241 7.2125 50.564 7.2125 45.8V32.2Z",
    stroke: "#D0D5DD",
    style: (_ref13 = {
      stroke: "#D0D5DD"
    }, _defineProperty(_ref13, "stroke", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref13, "strokeOpacity", 1), _ref13),
    strokeWidth: 0.425
  })), /*#__PURE__*/React.createElement("defs", null, _ref14, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1843_4617",
    x1: 41,
    y1: 5,
    x2: 41,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD",
    style: (_ref15 = {
      stopColor: "#D0D5DD"
    }, _defineProperty(_ref15, "stopColor", "color(display-p3 0.8144 0.8349 0.8656)"), _defineProperty(_ref15, "stopOpacity", 1), _ref15)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1843_4617",
    x1: 31.9121,
    y1: 36.9982,
    x2: 61.7058,
    y2: 39.4299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F639D1",
    style: (_ref16 = {
      stopColor: "#F639D1"
    }, _defineProperty(_ref16, "stopColor", "color(display-p3 0.9647 0.2235 0.8196)"), _defineProperty(_ref16, "stopOpacity", 1), _ref16)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#AB2EFF",
    style: (_ref17 = {
      stopColor: "#AB2EFF"
    }, _defineProperty(_ref17, "stopColor", "color(display-p3 0.6706 0.1804 1.0000)"), _defineProperty(_ref17, "stopOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FF",
    style: (_ref18 = {
      stopColor: "#00C7FF"
    }, _defineProperty(_ref18, "stopColor", "color(display-p3 0.0000 0.7804 1.0000)"), _defineProperty(_ref18, "stopOpacity", 1), _ref18)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1843_4617",
    x1: 21,
    y1: 28.6555,
    x2: 50.7936,
    y2: 31.0871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F639D1",
    style: (_ref19 = {
      stopColor: "#F639D1"
    }, _defineProperty(_ref19, "stopColor", "color(display-p3 0.9647 0.2235 0.8196)"), _defineProperty(_ref19, "stopOpacity", 1), _ref19)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#AB2EFF",
    style: (_ref20 = {
      stopColor: "#AB2EFF"
    }, _defineProperty(_ref20, "stopColor", "color(display-p3 0.6706 0.1804 1.0000)"), _defineProperty(_ref20, "stopOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FF",
    style: (_ref21 = {
      stopColor: "#00C7FF"
    }, _defineProperty(_ref21, "stopColor", "color(display-p3 0.0000 0.7804 1.0000)"), _defineProperty(_ref21, "stopOpacity", 1), _ref21)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1843_4617"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 32.2C7 22.6791 7 17.9187 8.85289 14.2822C10.4827 11.0834 13.0834 8.48274 16.2822 6.85289C19.9187 5 24.6791 5 34.2 5H47.8C57.3209 5 62.0813 5 65.7178 6.85289C68.9166 8.48274 71.5173 11.0834 73.1471 14.2822C75 17.9187 75 22.6791 75 32.2V45.8C75 55.3209 75 60.0813 73.1471 63.7178C71.5173 66.9166 68.9166 69.5173 65.7178 71.1471C62.0813 73 57.3209 73 47.8 73H34.2C24.6791 73 19.9187 73 16.2822 71.1471C13.0834 69.5173 10.4827 66.9166 8.85289 63.7178C7 60.0813 7 55.3209 7 45.8V32.2Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpearly2);
export default __webpack_public_path__ + "static/media/logo-spearly-2.8e04e4a2352de5763802239bd214aa17.svg";
export { ForwardRef as ReactComponent };